import { css } from "@microsoft/fast-element";
import { imageHoverStyles } from '../image/styles.js';

export default css`
  :host {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    gap: var(--padding-md);
  }

  ${imageHoverStyles(':host(:hover) site-image::part(image-container)', ':host(:hover) site-image::part(filter)')}

  :host(:not(:first-of-type)) {
    margin-top: var(--padding-md);
  }

  site-image {
    grid-column: 1;
    grid-row:1;
  }

  img {
    aspect-ratio: 1.77;
    max-height: 365px;
  }

  [part=body] {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    grid-row: 1;
    margin-top: auto;
    margin-bottom: auto;
    gap: 1.5rem;
  }

  :host([reverse]) site-image {
    grid-column: 2;
  }

  :host([reverse]) [part="body"] {
    grid-column: 1;
  }

  @media (max-width: 659px) {
    :host, :host([reverse]) {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr max-content;
    }

    site-image,
    :host([reverse]) site-image {
      grid-column: 1;
      grid-row: 1;
      max-width: unset;
    }

    [part="body"],
    :host([reverse]) [part="body"] {
      grid-column: 1;
      grid-row: 2;
      justify-content: flex-start;
      margin: 0;

    }

    img {
      aspect-ratio: 16 / 9;
    }
  }
`